module.exports = __webpack_public_path__ + "static/facebook-474b5da11cc41d790563ef47f49a79c7.png";